import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32ce8606"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "FTLOrderFiles" }
const _hoisted_2 = {
  key: 1,
  class: "FTLOrderFiles__empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_uploaded_file = _resolveComponent("uploaded-file")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.files.length)
      ? (_openBlock(), _createBlock(_component_uploaded_file, {
          key: 0,
          "is-visible": true,
          files: _ctx.files,
          "no-delete": ""
        }, null, 8, ["files"]))
      : _createCommentVNode("", true),
    (_ctx.files.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Нет файлов "))
      : _createCommentVNode("", true)
  ]))
}